/*
 * Venn Platform API 1.0.0 Operations for "autocomplete"
 * Automatically generated file - do not modify!
 */

import type { AutocompleteRequest, AutocompleteResponse, AutocompleteSearchRequest } from '../types';
import type { OperationResult } from '../../utils';
import { buildRequestInit, extractError, retryGeneratedFetch } from '../../utils';

/** Provide autocomplete results for investments, portfolios, optimizations */
export async function autocompleteSearch(
  body?: Partial<AutocompleteSearchRequest>,
  signal?: AbortSignal,
): Promise<OperationResult<AutocompleteResponse>> {
  const endpoint = '/api/autocomplete/search';
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await retryGeneratedFetch('POST', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: AutocompleteResponse = (await response.json()) as AutocompleteResponse;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Provide autocomplete results for portfolio analysis */
export async function autocomplete(
  body?: Partial<AutocompleteRequest>,
  signal?: AbortSignal,
): Promise<OperationResult<AutocompleteResponse>> {
  const endpoint = '/api/autocomplete';
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await retryGeneratedFetch('POST', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: AutocompleteResponse = (await response.json()) as AutocompleteResponse;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
